const ApproveSvg = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.3887 3.02656C11.3232 3.04849 10.7357 3.73548 8.54008 6.3578L5.774 9.66137L5.66982 9.53486C5.61251 9.4653 5.16117 8.88182 4.66679 8.23825C4.06704 7.45751 3.73544 7.04701 3.67028 7.00469C3.28292 6.75304 2.84981 7.26302 3.05099 7.73386C3.06831 7.77435 3.61373 8.49757 4.26308 9.34101C5.06895 10.3878 5.47484 10.8947 5.54179 10.938C5.65741 11.0128 5.8078 11.0205 5.93401 10.9581C6.03989 10.9058 11.911 3.90539 11.9668 3.765C12.0397 3.58137 11.9878 3.28652 11.8574 3.14323C11.7349 3.00865 11.5671 2.96687 11.3887 3.02656Z"
        fill="#D5D5D5"
        stroke="#D5D5D5"
        strokeWidth="0.455"
      />
    </svg>
  );
};

export default ApproveSvg;
